// extracted by mini-css-extract-plugin
export var clientSlide = "ClientRoll-module--client-slide--dnlRb";
export var image = "ClientRoll-module--image--BHlh9";
export var slider = "ClientRoll-module--slider--wJLQI";
export var sliderContainer = "ClientRoll-module--slider-container--1Q3UX";